import { Organization } from "src/types/graphql";
import * as RD from "src/types/remoteData";
import * as Url from "../url";

export * as avelaAdmin from "./avelaAdmin";
export * as avelaLabs from "./avelaLabs";
export * as capacities from "./capacities";
export * as dataServices from "./dataServices";
export * as enrollmentPeriod from "./enrollmentPeriod";
export * as form from "./form";
export * as landingPage from "./landingPage";
export * as match from "./match";
export * as matchTemplates from "./matchTemplates";
export * as messages from "./messages";
export * as organization from "./organization";
export * as parent from "./parent";
export * as payments from "./payments";
export * as school from "./school";
export * as student from "./student";
export * as team from "./team";
export * as userProfile from "./userProfile";

export type BreadcrumbType = {
  label: string;
  href: string;
};

export type BreadcrumbData =
  | BreadcrumbType
  | RD.RemoteData<unknown, BreadcrumbType>;

export const getBreadcrumbsForHome = (
  organization: RD.RemoteData<unknown, Organization>
): BreadcrumbType[] => {
  return [
    {
      label: "Home",
      href: organization.map((org) => Url.OrgAdmin.index(org)).withDefault("#"),
    },
  ];
};
